/*  eslint-disable @typescript-eslint/no-unsafe-member-access  */
/*  eslint-disable @typescript-eslint/no-unsafe-assignment  */
/*  eslint-disable @typescript-eslint/no-unsafe-return  */
/*  eslint-disable @typescript-eslint/no-unsafe-call  */
import type { NhostClient } from '@nhost/nhost-js';

export type NhostUserRole = 'admin' | 'user' | 'vendor' | 'trust';

/**
 * This patch would not be needed if we upgrade the nhost sdk
 * https://github.com/nhost/nhost/blob/2dd4df51708dddcd643f5100b4ff7c8666a262cb/docs/reference/javascript/nhost-js/set-role.mdx#L12
 */
export function patchNhostStorageHeaders({
  nhostClient,
  getRole,
  getUserId,
  getExtraHeaders,
}: {
  nhostClient: NhostClient;
  getRole: () => NhostUserRole | undefined;
  getUserId?(): string | undefined;
  getExtraHeaders?: () => Record<string, string> | undefined;
}): void {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: Accessing private property 'api'
  const storageApi = nhostClient.storage.api;
  const originalMethod: () => Record<string, string> =
    storageApi.constructor.prototype['generateAuthHeaders'] ?? (() => ({}));

  storageApi['generateAuthHeaders'] = function () {
    const headers = { ...originalMethod.call(this), ...getExtraHeaders?.() };

    maybeSetProp(headers, 'x-hasura-user-id', getUserId?.());
    maybeSetProp(headers, 'x-hasura-role', getRole());

    return headers;
  };
}

export function patchNhostGqlHeaders({
  nhostClient,
  getUserId,
  getRole,
  getExtraHeaders,
}: {
  nhostClient: NhostClient;
  getUserId?(): string | undefined;
  getRole?(): NhostUserRole | undefined;
  getExtraHeaders?: () => Record<string, string> | undefined;
}) {
  const graphql = nhostClient.graphql;
  const originalMethod: () => Record<string, string> =
    graphql.constructor.prototype['generateAccessTokenHeaders'] ?? (() => ({}));

  graphql['generateAccessTokenHeaders'] = function () {
    const headers = { ...originalMethod.call(this), ...getExtraHeaders?.() };

    maybeSetProp(headers, 'x-hasura-user-id', getUserId?.());
    maybeSetProp(headers, 'x-hasura-role', getRole?.());

    return headers;
  };
}

function maybeSetProp<T extends object>(obj: T, key: keyof T, value: T[keyof T] | undefined) {
  if (value !== undefined) {
    obj[key] = value;
  }
}
